import { render, staticRenderFns } from "./SpotItemCarousel.vue?vue&type=template&id=87c43394"
import script from "./SpotItemCarousel.vue?vue&type=script&lang=js"
export * from "./SpotItemCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports